var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex flex-col mx-1']},[_c('div',{class:[
      'flex items-start justify-between flex-1 py-2 results-choice-slide',
      {
        'ms-10': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
        'ms-9': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
        'ms-4.5': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1,
        'ms-3': !_setup.isDisplayModeSlideshow && _setup.isStream,
        'ms-2': !_setup.isDisplayModeSlideshow && !_setup.isStream,
      },
    ]},[_c('p',{class:[
        'me-1 break-word-anywhere',
        _setup.isDisplayModeExpandedOrSlideshow || _setup.isStream ? 'text-body' : 'text-body-small',
        {
          'text-dark-text-100': _setup.darkMode === false,
          'text-light-text-100': _setup.darkMode === true,
          'text-dark-text-100 dark:text-light-text-100': _setup.darkMode === 'auto',
        },
      ],attrs:{"data-testid":`surfacePostPollChoiceResult${_setup.index + 1}`}},[_vm._v("\n      "+_vm._s(_setup.result.choice_text)+"\n    ")]),_vm._v(" "),(_setup.result.user_voted)?_c(_setup.OzIcon,{class:[
        'me-auto my-auto',
        {
          'text-dark-text-200': _setup.darkMode === false,
          'text-light-text-200': _setup.darkMode === true,
          'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
        },
      ],attrs:{"name":'checkmark_thicker',"size":12}}):_vm._e(),_vm._v(" "),_c('div',{class:['ms-1 flex items-center my-auto', _setup.result.pollWinner ? 'poll-winner-slide' : 'poll-loser-slide']},[(_setup.result.pollWinner)?_c(_setup.OzIcon,{class:[
          'me-1',
          {
            [_setup.pollColors.pollWinnerIconText.light]: _setup.darkMode === false,
            [_setup.pollColors.pollWinnerIconText.dark]: _setup.darkMode === true,
            [_setup.pollColors.pollWinnerIconText.auto]: _setup.darkMode === 'auto',
          },
        ],attrs:{"name":'trophy',"size":16}}):_vm._e(),_vm._v(" "),_c('div',{class:[
          {
            'me-10': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
            'me-9': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
            'me-4.5': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1,
            'me-2': !_setup.isDisplayModeSlideshow && _setup.isStream,
            'me-1': !_setup.isDisplayModeSlideshow && !_setup.isStream,
          },
          {
            'text-dark-text-200': _setup.darkMode === false,
            'text-light-text-200': _setup.darkMode === true,
            'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
          },
        ]},[_vm._v("\n        "+_vm._s(_setup.decimalPercentage ? _setup.result.percentage.toFixed(1) : _setup.result.percentage.toFixed(0))+"%\n      ")])],1)],1),_vm._v(" "),_c('div',{class:[
      'relative',
      _setup.index !== _setup.numResults - 1 ? 'my-1' : 'mt-1',
      {
        'mx-7.5': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
        'mx-6': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
        'mx-3': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1,
        'mx-2': !_setup.isDisplayModeSlideshow && _setup.isStream,
        'mx-1': !_setup.isDisplayModeSlideshow && !_setup.isStream,
      },
    ]},[_c('div',{class:[
        'h-1 absolute rounded-s-sm vote-bar-animation',
        _setup.index === _setup.numResults - 1 && _setup.isDisplayModeExpandedOrSlideshow ? '-top-2.5' : '-top-0.875',
        _setup.result.percentage === 100 ? 'rounded-e-sm' : 'rounded-e-md ',
        {
          [_setup.pollColors.closedPollChoicePercentageBackground.light]: _setup.darkMode === false,
          [_setup.pollColors.closedPollChoicePercentageBackground.dark]: _setup.darkMode === true,
          [_setup.pollColors.closedPollChoicePercentageBackground.auto]: _setup.darkMode === 'auto',
        },
      ],style:({
        width: _setup.result.percentage === 0 ? `4px` : `${_setup.result.percentage}%`,
      })}),_vm._v(" "),_c(_setup.OzDivider,{class:[_setup.index === _setup.numResults - 1 && _setup.isDisplayModeExpandedOrSlideshow && '-translate-y-1.5'],attrs:{"dark-mode":_setup.darkMode,"color-scheme":_setup.OzDividerColorScheme.Solid}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }